import { Fragment } from 'react'

import { ContentPage_content_EventContent } from 'globalTypes'
import { filter, isEmpty, map } from 'lodash'

import CoverImage from 'Root/App/CoverImage'
import CallToAction from 'Root/App/Event/CallToAction'
import StatusLabel from 'Root/App/Event/StatusLabel'
import DateRange from 'Root/App/Item/DateRange'
import LocationOrUrl from 'Root/App/Item/LocationOrUrl'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import RenderedHtml from 'Root/Component/RenderedHtml'
import Item from 'Root/Pages/Collection/Component/Contents/Item'
import BottomContent from 'Root/Pages/Content/Component/BottomContent'

interface Props {
  content: ContentPage_content_EventContent
}

const DefaultStatus = ({ content }: Props) => {
  const filtered = filter([
    content.label,
    <StatusLabel key={`status_label_${content.id}`} status={content.status} />,
  ])

  const hasCover = Boolean(content.cover)

  return (
    <Fragment>
      {hasCover && (
        <CoverImage
          imageUrl={content.cover}
          dimensions={content.coverDimensions}
        />
      )}
      <div className="flex flex-col gap-y-3 p-3">
        <div className="flex flex-col gap-y-3">
          <PreTitle className="-m-1">
            {filtered.reduce(
              (acc, x) =>
                acc === null ? (
                  x
                ) : (
                  <Fragment>
                    {acc} · {x}
                  </Fragment>
                ),
              null
            )}
          </PreTitle>
          <Title maxRows={3}>{content.title}</Title>

          <DateRange content={content} isOnPage />
          <LocationOrUrl content={content} />

          {Boolean(content.description) && (
            <Paragraph>{content.description}</Paragraph>
          )}

          {Boolean(content.presentation) && (
            <RenderedHtml className="p-6" value={content.presentation} />
          )}
        </div>

        {!isEmpty(content.relatedContents) && (
          <div className="flex flex-col gap-y-3">
            <Title size="XS">Contenuti correlati</Title>
            <div className="flex flex-col gap-y-3">
              {map(content.relatedContents, (content) => (
                <Item key={content.id} content={content} />
              ))}
            </div>
          </div>
        )}

        <List tags={content.tags} />

        <CallToAction content={content} />

        <BottomContent content={content} />
      </div>
    </Fragment>
  )
}

export default DefaultStatus
